export default __webpack_public_path__ + "AWS_logo.c3069dbb.svg";